var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"label-image"},[_c('div',{staticClass:"labeled-image"},[_c('canvas',{staticClass:"labeled-image__double",staticStyle:{"z-index":"-1"},attrs:{"width":"900","height":"500","id":"canvas"}}),_c('canvas',{staticClass:"labeled-image__double",staticStyle:{"z-index":"0"},attrs:{"width":"900","height":"500","id":"canvas2"}})])])])
}]

export { render, staticRenderFns }